<template>
  <ContentPage title="Contact Us" page="contact">
    <p>
      If you have questions, feedback, copyright concerns, or need assistance with SnapInsta, please
      contact us by email.
    </p>
    <p>
      <strong>Email: <a href="mailto:support@snapsinsta.com">support@snapsinsta.com</a></strong>
    </p>
    <p>
      For copyright-related requests, please include the URL or other information that can help us
      identify the relevant content.
    </p>
    <p>We will review your message and respond as soon as reasonably possible.</p>
  </ContentPage>
</template>

<script>
import ContentPage from '@/components/ContentPage.vue';

export default {
  name: 'ContactUs',
  components: {
    ContentPage,
  },
};
</script>
